import { Block } from 'baseui/block';
import {
    DisplayXSmall,
    LabelLarge,
    LabelMedium,
    LabelXSmall,
} from 'baseui/typography';
import { useStyletron } from 'baseui';

import { IPID } from './types'
import { ValueDisplayWithLabel } from '../../components/ValueDisplay';
import { FormattedMessage } from 'react-intl';

export function SmallPanel(props: IPID) {
    const [css, theme] = useStyletron();

    return (
        <Block display='flex' flexDirection='row' alignItems='center' justifyContent='center' gridGap='20px'>
            <Block display='flex' flexDirection='column' alignItems='center' justifyContent='center' gridGap='5px'>
                <ValueDisplayWithLabel small label={<FormattedMessage id='Functions.Setpoint' defaultMessage={'Setpoint'}></FormattedMessage>} dimension={props.xDimension} value={props.w}></ValueDisplayWithLabel>
                <ValueDisplayWithLabel small label={<FormattedMessage id='Functions.ActualValue' defaultMessage={'Actual value'}></FormattedMessage>} dimension={props.xDimension} value={props.x}></ValueDisplayWithLabel>
            </Block>
            <div className={
                css({
                    border: `${theme.colors.mono500} solid 1px`,
                    background: theme.colors.mono300,
                    padding: '5px 15px 5px 15px',
                })
            }><LabelMedium color={theme.colors.mono800}>PID</LabelMedium></div>
            <ValueDisplayWithLabel small label={<FormattedMessage id='Functions.Output' defaultMessage={'Output'}></FormattedMessage>} dimension={props.yDimension} value={props.y}></ValueDisplayWithLabel>

        </Block>
    );
}